__turbopack_context__.v({
  "buttonGroup": "MiniProductStrip-module-scss-module__JYEqVa__buttonGroup",
  "header": "MiniProductStrip-module-scss-module__JYEqVa__header",
  "heading": "MiniProductStrip-module-scss-module__JYEqVa__heading",
  "navButton": "MiniProductStrip-module-scss-module__JYEqVa__navButton",
  "root": "MiniProductStrip-module-scss-module__JYEqVa__root",
  "slide": "MiniProductStrip-module-scss-module__JYEqVa__slide",
  "swiper": "MiniProductStrip-module-scss-module__JYEqVa__swiper",
});
